$.fn.customerPlugin = function (options) {
  	'use strict';

  	var _elem = $(this),  // instance to $('#selector')
      	_this = this;     // instance to this plugin

  	// custom variables
  	var o = $.extend({

  	}, options);

  	_this.init = function()
    {
        /***************************************************************************
         ***************************************************************************
         *
         *   Copy to clipboards groups
         *
         ***************************************************************************
         ****************************************************************************/
        var clipboard = new Clipboard('.copyClipboard');
        var copied_feedback = $('.copied-feedback');
        var timeout;

        clipboard.on('success', function(e) {
            clearTimeout(timeout);
            copied_feedback.stop(true, false).fadeIn(300);

            timeout = setTimeout(function() {
                copied_feedback.stop(true, false).fadeOut(300);
            }, 1500);
        });

        /***************************************************************************
         ***************************************************************************
         *
         *   Globally select with targets
         *
         ***************************************************************************
         ****************************************************************************/
        $('select.autofill-target').on('change', function(e) {
            var that    = $(this);
            var val     = that.val();
            var tarName = that.data('input-target-name');
            var tarVal  = that.find('option:selected').data('target-val');

            var target  = $('input[name="'+tarName+'"]');

            if (target)
                target.val(tarVal);
        });
  	};

  	_this.init();
};